import debounce from 'lodash/debounce';
import throttle from 'lodash/throttle';
import { createDecorator } from 'vue-class-component';

function Debounce(delay: number) {
  return (target: any, key: string) => {
    const isClassComponentVueInstance = !!target?.created;
    if (isClassComponentVueInstance) {
      return createDecorator((options, k) => {
        const originalMethod = options.methods[key];
        options.methods[key] = debounce(originalMethod, delay);
      })(target, key);
    } else {
      return {
        configurable: true,
        enumerable: true,
        value: debounce(target[key], delay)
      };
    }
  };
}

function Throttle(delay: number) {
  return (target: any, key: string) => {
    const isClassComponentVueInstance = !!target?.created;
    if (isClassComponentVueInstance) {
      return createDecorator((options, k) => {
        const originalMethod = options.methods[key];
        options.methods[key] = throttle(originalMethod, delay);
      })(target, key);
    } else {
      return {
        configurable: true,
        enumerable: true,
        value: throttle(target[key], delay)
      };
    }
  };
}

export { Debounce, Throttle };
